/**
 * Format a decimal value to percentage string
 * @param {number} value - Value that could be already as percentage (0-100) or decimal (0-1)
 * @returns {string} Formatted percentage (e.g., 45 → "45%" or 0.45 → "45%")
 */
export function formatPercent(value) {
  if (value === null || value === undefined) return '-';
  // If value is less than or equal to 1, assume it's a decimal (0-1) and multiply by 100
  // Otherwise, assume it's already a percentage (0-100)
  const percentValue = value <= 1 ? Math.round(value * 100) : Math.round(value);
  return `${percentValue}%`;
}

/**
 * Format date from YYYY-MM-DD to DD/MM/YYYY
 * @param {string} value - Date in YYYY-MM-DD format
 * @returns {string} Formatted date in DD/MM/YYYY format
 */
export function formatDate(value) {
  if (!value) return '-';
  const [year, month, day] = value.split('-');
  return `${day}/${month}/${year}`;
}

/**
 * Format date to display format
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date
 */
export function formatDisplayDate(date) {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleDateString('es-CO', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
}

/**
 * Format number with thousands separator
 * @param {number} value - Number to format
 * @returns {string} Formatted number
 */
export function formatNumber(value) {
  if (value === null || value === undefined) return '-';
  return new Intl.NumberFormat('es-CO').format(value);
}

export default {
  formatPercent,
  formatDate,
  formatDisplayDate,
  formatNumber
};
